/**
 * Tipos, enums e labels do plano "Personalizado" (redes de ensino/secretarias).
 *
 * Estes labels são espelhados em `supabase/functions/submit-custom-plan-request/index.ts`
 * porque a Edge Function roda em Deno e não pode importar de `src/` — ao alterar
 * qualquer valor aqui, replicar manualmente na função também.
 */
import type { Database } from './database'

export type CustomPlanRequest = Database['public']['Tables']['custom_plan_requests']['Row']
export type CustomPlanRequestUpdate = Pick<Database['public']['Tables']['custom_plan_requests']['Update'], 'status' | 'internal_notes'>

export type CustomPlanRequestStatus = 'new' | 'contacted' | 'proposal_sent' | 'won' | 'lost'
export type OrganizationType = 'rede_escolas' | 'secretaria' | 'escola' | 'outro'
export type TeachersRange = 'ate_10' | '11_50' | '51_200' | 'mais_200'
export type CustomPlanSource = 'billing' | 'landing' | 'trial' | 'direct'

export const CUSTOM_PLAN_STATUSES: CustomPlanRequestStatus[] = ['new', 'contacted', 'proposal_sent', 'won', 'lost']
export const ORGANIZATION_TYPES: OrganizationType[] = ['rede_escolas', 'secretaria', 'escola', 'outro']
export const TEACHERS_RANGES: TeachersRange[] = ['ate_10', '11_50', '51_200', 'mais_200']

export const STATUS_LABELS: Record<CustomPlanRequestStatus, string> = {
  new: 'Novo', contacted: 'Contatado', proposal_sent: 'Proposta enviada', won: 'Fechado', lost: 'Perdido',
}
export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  rede_escolas: 'Rede de escolas', secretaria: 'Secretaria de Educação', escola: 'Escola', outro: 'Outro',
}
// Short form; the public form appends " professores" itself.
export const TEACHERS_RANGE_LABELS: Record<TeachersRange, string> = {
  ate_10: 'Até 10', '11_50': '11 a 50', '51_200': '51 a 200', mais_200: 'Mais de 200',
}
export const SOURCE_LABELS: Record<CustomPlanSource, string> = {
  billing: 'Página de planos', landing: 'Landing page', trial: 'Fim do trial', direct: 'Acesso direto',
}

export interface CustomPlanRequestFilters {
  status?: CustomPlanRequestStatus
  search?: string   // nome, e-mail ou organização
  page?: number     // 1-based
  limit?: number    // default 20
}
